import { render, staticRenderFns } from "./SkeletonInputsOutputsComponent.vue?vue&type=template&id=2205d676&scoped=true&"
import script from "./SkeletonInputsOutputsComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonInputsOutputsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonInputsOutputsComponent.vue?vue&type=style&index=0&id=2205d676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205d676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
